import type {ReactElement} from 'react';
import type {SliderOptionsContainerProps} from './slider-options-container.types';
import styles from './slider-options-container.module.scss';

export function SliderOptionsContainer({className = '', ...props}: SliderOptionsContainerProps): ReactElement<any> {
  return (
    <div key={props.id} data-testid={props.id.toUpperCase()} className={`${className} flex-v-row ${styles.container}`}>
      <div className={`flex-row-justify-between flex-items-center spacing-m-b-3 ${styles.upperContainer}`}>{props.upperContainer}</div>
      {props.slider}
    </div>
  );
}
